import { Route } from '@angular/router'
import { AdminRoutes, adminRoutes } from './pages/admin/admin.routes'
import {
    appointmentsRoutes,
    AppointmentsRoutes,
} from './pages/appointments/appointments.routes'
import {
    AuditLogRoutes,
    auditLogRoutes,
} from './pages/audit-log/audit-log.routes'
import { AuthRoutes, authRoutes } from './pages/auth/auth.routes'
import {
    BusinessRoutes,
    businessRoutes,
} from './pages/business/business.routes'
import {
    CalendarRoutes,
    calendarRoutes,
} from './pages/calendar/calendar.routes'
import { ClientRoutes, clientRoutes } from './pages/client/client.routes'
import {
    CommunicationRoutes,
    communicationRoutes,
} from './pages/communication/communication.routes'
import {
    DocumentsRoutes,
    documentsRoutes,
} from './pages/documents/documents.routes'
import {
    FeedbackRoutes,
    feedbackRoutes,
} from './pages/feedback/feedback.routes'
import { HomeRoutes, homeRoutes } from './pages/home/home.routes'
import { InvoiceRoutes, invoiceRoutes } from './pages/invoice/invoice.routes'
import {
    NewsletterRoutes,
    newsletterRoutes,
} from './pages/newsletter/newsletter.routes'
import {
    NotFoundRoutes,
    notFoundRoutes,
} from './pages/not-found/not-found.routes'
import {
    NotificationRoutes,
    notificationRoutes,
} from './pages/notification/notification.routes'
import {
    OrganizationRoutes,
    organizationRoutes,
} from './pages/organization/organization.routes'
import {
    LookbookRoutes,
    lookbookRoutes,
} from './pages/page-lookbooks/lookbook.routes'
import {
    MarketplaceRoutes,
    marketplaceRoutes,
} from './pages/page-marketplace/marketplace.routes'
import {
    PrivacyPolicyRoutes,
    privacyPolicyRoutes,
} from './pages/privacy-policy/privacy-policy.routes'
import { ProfileRoutes, profileRoutes } from './pages/profile/profile.routes'
import {
    PublicShopsRoutes,
    publicShopsRoutes,
} from './pages/public-shops/public-shops.routes'
import {
    PublicWebsiteRoutes,
    publicWebsiteRoutes,
} from './pages/public-website/public-website.routes'
import { PublicRoutes, publicRoutes } from './pages/public/public.routes'
import {
    ReferralRoutes,
    referralRoutes,
} from './pages/referral/referral.routes'
import {
    RoleSelectionRoutes,
    roleSelectionRoutes,
} from './pages/role-selection/role-selection.routes'
import {
    SettingsRoutes,
    settingsRoutes,
} from './pages/settings/settings.routes'
import { TasksRoutes, tasksRoutes } from './pages/tasks/tasks.routes'
import {
    WaitlistRoutes,
    waitlistRoutes,
} from './pages/waitlist/waitlist.routes'
import {
    WebsiteDashboardRoutes,
    websiteDashboardRoutes,
} from './pages/website/website.routes'

type AppRouteGroups = [
    AuthRoutes,
    HomeRoutes,
    ClientRoutes,
    OrganizationRoutes,
    AppointmentsRoutes,
    BusinessRoutes,
    CalendarRoutes,
    WebsiteDashboardRoutes,
    PublicRoutes,
    PublicShopsRoutes,
    PrivacyPolicyRoutes,
    LookbookRoutes,
    MarketplaceRoutes,
    WaitlistRoutes,
    ProfileRoutes,
    SettingsRoutes,
    AuditLogRoutes,
    AdminRoutes,
    CommunicationRoutes,
    DocumentsRoutes,
    FeedbackRoutes,
    InvoiceRoutes,
    NewsletterRoutes,
    NotificationRoutes,
    ReferralRoutes,
    RoleSelectionRoutes,
    TasksRoutes,
    PublicWebsiteRoutes,
    NotFoundRoutes,
]

const groupedRoutes: AppRouteGroups = [
    authRoutes,
    homeRoutes,
    clientRoutes,
    organizationRoutes,
    appointmentsRoutes,
    businessRoutes,
    calendarRoutes,
    websiteDashboardRoutes,
    publicRoutes,
    publicShopsRoutes,
    privacyPolicyRoutes,
    lookbookRoutes,
    marketplaceRoutes,
    waitlistRoutes,
    profileRoutes,
    settingsRoutes,
    auditLogRoutes,
    adminRoutes,
    communicationRoutes,
    documentsRoutes,
    feedbackRoutes,
    invoiceRoutes,
    newsletterRoutes,
    notificationRoutes,
    referralRoutes,
    roleSelectionRoutes,
    tasksRoutes,
    publicWebsiteRoutes,
    notFoundRoutes,
]

const flattenedRoutes: Route[] = []
for (const routeGroup of groupedRoutes) {
    for (const route of Object.values(routeGroup)) {
        flattenedRoutes.push(route)
    }
}

export const appRoutes = flattenedRoutes
